import SectionTitle from './SectionTitle'
import Entry from './Entry'
import React from 'react'

export default function Education() {
    return (
        <section>
            <SectionTitle title="Education" />
            <div className="mt-6 space-y-8">
                <Entry
                    title="Bachelor of Science in Computer Engineering"
                    dates="May 2014"
                    company="University of Puerto Rico at Mayagüez"
                    location="Mayagüez, PR"
                />
            </div>
        </section>
    )
}
